<template>
  <header class="__navigation">
    <div class="container">
      <section>
        <div class="left">
          <h3 class="logo is-hidden-mobile">STMNC Votes</h3>
          <div class="links">
            <router-link
              v-if="userStore.isShareholder"
              to="/dashboard"
              :class="{ active: $route.name === 'Dashboard' }"
            >
              Dashboard
            </router-link>
            <router-link v-if="userStore.isAdmin" to="/admin" class="admin-link">
              Admin
            </router-link>
          </div>
        </div>
        <div class="logo-image" />
        <div class="user">
          <span class="name is-hidden-mobile">
            {{ userStore.profile.name }}
          </span>
          <span
            class="icon_button"
            :title="theme === 'dark' ? 'Switch to light mode' : 'Switch to dark mode'"
            @click="toggle"
          >
            <i :class="theme === 'dark' ? 'pi pi-sun' : 'pi pi-moon'" />
          </span>
          <router-link to="/settings" class="icon_button" title="User Settings">
            <i class="pi pi-user-edit" />
          </router-link>
          <span class="icon_button" title="Sign Out" @click="signout">
            <i class="pi pi-sign-out" />
          </span>
        </div>
      </section>
    </div>
  </header>
</template>

<script setup>
import { useUserStore } from '@/stores/user'
import { useRouter } from 'vue-router'
import { useTheme } from '@/composables/useTheme'

const userStore = useUserStore()
const router = useRouter()
const { theme, toggle } = useTheme()

async function signout() {
  await userStore.signout()
  router.push('/login')
}
</script>

<style lang="scss">
@use '@/theme.scss' as *;

.__navigation {
  height: 50px;
  width: 100%;
  // Flips to a darker shade in dark mode (see App.vue :root overrides) so the
  // navbar doesn't glow against the charcoal page background.
  background-color: var(--navbar-bg, #{$primary});
  color: white;
  position: fixed;
  top: 0px;
  z-index: 100;

  .active {
    border-bottom: 3px solid #ffc3c3;
  }

  .router-link-exact-active {
    border-bottom: 3px solid #ffc3c3;
    margin-top: -3px;

    .icon_button {
      line-height: 65px;
    }
  }

  section {
    display: flex;
    flex-direction: row;
    justify-content: space-between;
  }

  .left {
    display: inline-flex;
    flex-direction: row;
  }

  .logo {
    height: 50px;
    line-height: 50px;
    width: 150px;
    color: white;
  }

  a,
  a:visited {
    color: white;
  }

  .links {
    display: inline-flex;
    flex-direction: row;
    height: 50px;
    line-height: 50px;

    a {
      padding: 0 16px;
      height: 50px;
      display: block;
      text-align: center;

      &:hover {
        background-color: white;
        color: $primary;
      }
    }
  }

  .logo-image {
    width: 45px;
    height: 45px;
    background-image: url('/img/logo_white.png');
    background-size: contain;
    background-repeat: no-repeat;
  }

  .user {
    display: inline-flex;
    flex-direction: row;
    align-items: center;

    .name {
      height: 50px;
      line-height: 50px;
      margin: 0px 10px;
    }
  }

  .icon_button {
    width: 50px;
    height: 50px;
    display: inline-flex;
    align-items: center;
    justify-content: center;
    cursor: pointer;

    &:hover {
      background-color: white;
      color: $primary;
    }

    i {
      font-size: 18px;
    }
  }
}
</style>
